// Shop meta JS placeholder.
(() => {
  const el = document.querySelector(".c-product-shop-meta");
  if (!el) return;
})();

